/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type HomePage_viewer$ref = any;
export type HomePage_QueryVariables = {};
export type HomePage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": HomePage_viewer$ref;
    }) | null;
};
export type HomePage_Query = {
    readonly response: HomePage_QueryResponse;
    readonly variables: HomePage_QueryVariables;
};



/*
query HomePage_Query {
  viewer {
    id
    ...HomePage_viewer
  }
}

fragment HomePage_viewer on Viewer {
  id
  isLoggedIn
  user {
    id
    userId
    conciergeCustomerAccountId
    segmentPersonas {
      prospects
      id
    }
    availableTastingFlightCode {
      code
      expiresOn
      id
    }
    conciergeUser {
      userId
      permissions {
        id
        oneCommerce {
          id
          preferredCustomer {
            access
          }
        }
      }
      id
    }
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
        preferredCustomer {
          access
        }
      }
    }
    email
    role
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "preferredCustomer",
        "storageKey": null,
        "args": null,
        "concreteType": "AccessType",
        "plural": false,
        "selections": (v2 /*: any*/)
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "HomePage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "HomePage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "HomePage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isLoggedIn",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "conciergeCustomerAccountId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "segmentPersonas",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SegmentPersonas",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "prospects",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "availableTastingFlightCode",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WordPressCoupon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "code",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expiresOn",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "permissions",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PermissionsType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "oneCommerce",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "OneCommerceType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        (v3 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": (v2 /*: any*/)
                                                },
                                                (v3 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "HomePage_Query",
            "id": null,
            "text": "query HomePage_Query {\n  viewer {\n    id\n    ...HomePage_viewer\n  }\n}\n\nfragment HomePage_viewer on Viewer {\n  id\n  isLoggedIn\n  user {\n    id\n    userId\n    conciergeCustomerAccountId\n    segmentPersonas {\n      prospects\n      id\n    }\n    availableTastingFlightCode {\n      code\n      expiresOn\n      id\n    }\n    conciergeUser {\n      userId\n      permissions {\n        id\n        oneCommerce {\n          id\n          preferredCustomer {\n            access\n          }\n        }\n      }\n      id\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    email\n    role\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8227e6f5cf906b8722d0ac560163f18f';
export default node;
